module.exports = __webpack_public_path__ + "img/user.614db618.png";